import React from "react";
import { Nav } from "./Nav";

export const TopNav = ({ focus, onClose, onPrev }) => {
    return focus ? (
        <div className="interactive-signup__top-nav interactive-signup__top-nav--mobile">
            <Nav onClick={onPrev} direction="prev" isMobile />
            <i
                className="fa fa-times-circle fa-4x interactive-signup-overlay__close-icon interactive-signup-overlay__close-icon--mobile"
                onClick={onClose}
            />
        </div>
    ) : null;
};
